import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from "./utility/roleRedirect";

import NotFound from "./pages/NotFound";
import NotAuthorised from "./pages/UnauthorizedPage";


import RawAuth from "./pages/LoginPage";  
import Signup from "./pages/SignupComponent";  
import EcommerceStore from "./pages/market/EcommerceStore"; 

import SupplierDashboard from "./pages/suppliers/SupplierDashboard"
import BuyerDashboard from "./pages/buyers/BuyerDashboard";

import ProductRegistration from './pages/suppliers/ProductRegistration';
import ProductManagement from './pages/suppliers/ProductManagement';
import SupplierCustomers from './pages/suppliers/SupplierCustomers';
import SupplierOrders from './pages/suppliers/SupplierOrders';


import BuyerOrderManagement from './pages/buyers/BuyerOrderManagement';
//import Checkout from './pages/buyers/Checkout';
import SupplierManagement from './pages/buyers/SupplierManagement';



import ProductMan from './pages/RMRDC/ProductMan';
import SupplierMan from './pages/RMRDC/SupplierMan';
import RmrdcDashboard from "./pages/RMRDC/RmrdcDashboard";
import UserManagement from './pages/RMRDC/UserManagement';
import RmrdcOrders from './pages/RMRDC/RmrdcOrders';
import AdvancedAnalytics from './pages/RMRDC/AdvancedAnalytics';




function App() {
  return (
    <Router>
      <Routes>



        {/* Departmental Auths Route */}
        <Route path="/RawAuth" element={<RawAuth />} />  

        {/* mkt Route */}
        <Route path="/EcommerceStore" element={<EcommerceStore />} />  

  <Route path="/signup" element={<Signup />} />  


<Route path="/supplier/dashboard" element={
  <ProtectedRoute allowedRoles={['supplier']}>
    <SupplierDashboard />
  </ProtectedRoute>
} />
      

<Route path="/supplier/orders" element={
  <ProtectedRoute allowedRoles={['supplier']}>
    <SupplierOrders />
  </ProtectedRoute>
} />




  <Route path="/supplier/customers" element={
  <ProtectedRoute allowedRoles={['supplier']}>
    <SupplierCustomers />
  </ProtectedRoute>
} />

  <Route path="/supplier/product" element={
  <ProtectedRoute allowedRoles={['supplier']}>
    <ProductManagement />
  </ProtectedRoute>
} />



  <Route path="/supplier/ProductRegistration" element={
  <ProtectedRoute allowedRoles={['supplier']}>
    <ProductRegistration />
  </ProtectedRoute>
} />

  <Route path="/buyer/orders" element={
          <ProtectedRoute allowedRoles={['buyer']}>
            <BuyerOrderManagement />
          </ProtectedRoute>
        } />



      <Route path="/buyer/dashboard" element={
  <ProtectedRoute allowedRoles={['buyer']}>
    <BuyerDashboard />
  </ProtectedRoute>
} />



<Route path="/buyer/SupplierManagement" element={
  <ProtectedRoute allowedRoles={['buyer']}>
    <SupplierManagement />
  </ProtectedRoute>
} />

<Route path="/rmrdc/Dashboard" element={
  <ProtectedRoute allowedRoles={['super_admin']}>
    <RmrdcDashboard />
  </ProtectedRoute>
} />

<Route path="/rmrdc/orders" element={
  <ProtectedRoute allowedRoles={['super_admin']}>
    <RmrdcOrders />
  </ProtectedRoute>
} />

<Route path="/rmrdc/analytics" element={
  <ProtectedRoute allowedRoles={['super_admin']}>
    <AdvancedAnalytics />
  </ProtectedRoute>
} />

<Route path="/rmrdc/users" element={
  <ProtectedRoute allowedRoles={['super_admin', 'rmrdc']}>
    <UserManagement />
  </ProtectedRoute>
} />

<Route path="/rmrdc/Dashboard/suppliers" element={
  <ProtectedRoute allowedRoles={['super_admin', 'rmrdc']}>
    <SupplierMan />
  </ProtectedRoute>
} />


<Route path="/rmrdc/products" element={
  <ProtectedRoute allowedRoles={['super_admin', 'rmrdc']}>
    <ProductMan />
  </ProtectedRoute>
} />

{/* 
<Route path="/checkout" element={<Checkout />} />
 */}

        {/* 404 - Catch all unmatched routes */}
        <Route path="*" element={<NotFound />} />      
         
 <Route path="/" element={<EcommerceStore />} />      
      
         

      </Routes>
    </Router>
  );
}

export default App;
